import api from '../_api';

export const eventsService = {
  fetchFiltered(filters) {
    return api.get('/events/', {
      params: filters,
    });
  },
  // fetchFilteredCustomerEvents(filters) {
  //     return api.get(`/customer-events/`, {
  //         params: filters
  //     });
  // },
  fetchClickedLinks(outreach, page, page_size) {
    return api.get(`/outreach/${outreach}/clicked-links`, {
      params: {
        page,
        page_size,
      },
    });
  },
  fetchClientOpens(outreach, page, page_size) {
    return api.get('/customer-events/', {
      params: {
        event: 'open',
        page,
        outreach,
        page_size,
      },
    });
  },
  saveClickEvent(data) {
    return api.post('/events/create_appointment_like/', data);
  },
};
